// import axios from 'axios'
import store from '@/store'
// import config from '@/config'
// import moment from 'moment'
import method from './methods'
const GeoComply = window.GeoComply

// var geoLicenseTimer
// var checkGeoLocationRequestTimer
// var checkGeoLocationRequestArray = []
// var checkGeoLocationBoolean
// var checkGeoLocationTime
// var locationMessageKey
// var locationMessage
// var locationState
// var checkGeoLocationTimeDefault
// var checkGeoLocationTimeCount
// var storeGeoLocationRequestArray = []
// var passedGeoLoction
// var storeGeoLocationCount
// var inGameGeoLocation = true
var userLicense
var storeIsGeolocated
// var timerCheck
// var errorMsgCode = [615, 612, 602, 604, 605]
// var availableInstances = ['wv']
var logInitArray = []
// var logIntervalArray = []
// var logErrorArray = []
// var externalURL = config.externalUrls.geocomplyURL
// var siteInstance = (window.ctsautoconf.HARDGEOLOCATION) ? window.ctsautoconf.STATE.toLowerCase() : ''
// var stateLicense = (window.ctsautoconf.HARDGEOLOCATION) ? window.ctsautoconf.STATE : ''
var FDstateInstance = window.ctsautoconf.STATE
// var locationSuccess = false

function geoComplyMockupService (validGeolocation) {
  console.info(' ----- MOCKUP GAN GEOCOMPLY -----')
  new Promise((resolve, reject) => {
    var errorCode = 'verify'
    store.commit('overlayState/setGeolocationMessage', {errorCode})
    setTimeout(() => validGeolocation ? resolve(validGeolocation) : reject(validGeolocation), 5000)
  }).then(() => {
    store.commit('overlayState/setGeolocationMessage', {})
    localStorage.setItem('gcPerm', true)
    store.commit('setGeolocated', true)
    localStorage.setItem('geoError', false)
    store.commit('overlayState/setGeolocationMessage', {})
  }, () => {
    store.commit('overlayState/setGeolocationMessage', {})
    localStorage.setItem('gcPerm', false)
    store.commit('setGeolocated', false)
    let errorCode = 999
    let errorMessage = ''
    localStorage.setItem('geoError', errorCode)
    store.commit('overlayState/setGeolocationMessage', { errorCode, errorMessage })
    store.dispatch('overlayState/activeGeolocationDialog')
  }
  )
}

function geoComplyService (user, sessionId, reason = 'Login') {
  method.resetGeoError()
  method.geoComplyDisconnectService()
  method.connectGeoComplyService()
  logInitArray.push({'user_id': user, 'gelocation_reason': reason, 'state': FDstateInstance})
  GeoComply.Client.on('connect', () => {
    sessionStorage.setItem('geolocationInProgress', reason)
    console.log('GC Connected')
    if (reason === 'Login' || reason === 'Retry') {
      method.showSpinnerOnStart()
    }
    logInitArray.push({'geocomply_connected': GeoComply.Client.isConnected()})
    GeoComply.Client.setLicense('')
    if (typeof localStorage !== 'undefined') {
      userLicense = ('userLicense' + FDstateInstance in localStorage) ? localStorage.getItem('userLicense' + FDstateInstance) : localStorage.setItem('userLicense' + FDstateInstance, undefined)
      storeIsGeolocated = ('gcPerm' in localStorage) ? localStorage.getItem('gcPerm') : localStorage.setItem('gcPerm', false)
      store.commit('setGeolocated', storeIsGeolocated)
      if (userLicense === 'undefined' || userLicense === undefined) {
        method.getGeoLicense(user, sessionId, reason)
      } else if (userLicense !== undefined) {
        GeoComply.Client.setLicense(JSON.parse(userLicense).license)
        console.log('user')
        console.log(user)
        method.validateLicense(user, sessionId, reason)
      }
    } else {
      method.getGeoLicense(user, sessionId, reason)
    }
  }).on('error', (errorCode, errorMessage) => {
    console.log('---- GC SERVICE ERROR ----')
    method.errorHandler(errorCode, errorMessage, user, reason)
  }).on('geolocation', (data) => {
    console.log('--- geoPacket ----')
    console.log(data)
    method.geocomplySubmit(data, user)
  }).on('log', (log) => {
    console.log(log)
  })
  console.log('logInitArray')
  console.log(logInitArray)
}
export default {
  methods: {},
  computed: {},
  components: {},
  watch: {},
  method,
  geoComplyService,
  geoComplyMockupService
}



// WEBPACK FOOTER //
// ./src/library/geocomply/index.js